<template>
	<span :style="`color:${val>0?'#f6465d':'#2ebd85'}`">
		{{val>0?'+':''}} {{val}}
	</span>
</template>

<script>
export default {
	props: {
		val: {
			type: [Number,String],
			default: 0
		},
	},
}
</script>

<style></style>
